import { api } from '../api/client';
import { API_COLLECTIONS_URL } from '../utils';
import { normalizeId } from '../utils/ids';

/**
 * COLLECTION READS for the parts of the client that only need to know what a
 * collection IS — its name, icon and colour — rather than to work inside it
 * (hooks/useCollectionIdentity, the qualified badge's resolver). Pages that
 * open a collection keep reading it their own way (CollectionsLayout).
 *
 * Both answer only what the caller may read: the list is the collections the
 * account belongs to, and a single read is the API's own access check (a 404
 * or 403 for one the caller cannot open, which the resolver turns into "no
 * qualifier" — never a guess).
 */

/** `GET /api/collections` — every collection the signed-in account can read, as an array. */
export async function listCollections() {
	const { data } = await api.get(API_COLLECTIONS_URL);
	return Array.isArray(data) ? data : [];
}

/** `GET /api/collections/{id}` — one collection's document, or null when the answer is not one. */
export async function getCollection(collectionId) {
	const id = normalizeId(collectionId);
	if (!id) return null;
	const { data } = await api.get(`${API_COLLECTIONS_URL}/${id}`);
	return data && typeof data === 'object' && !Array.isArray(data) ? data : null;
}
